export function toPossessive(str: string): string {
  return str.endsWith("s") ? `${str}'` : `${str}'s`;
}

export function pluralize(
  count: number,
  singular: string,
  plural: string,
): string {
  return count === 1 ? singular : plural;
}

// Source - https://stackoverflow.com/a/63763497
// Posted by chickens, modified by community. See post 'Timeline' for change history
// Retrieved 2026-03-12, License - CC BY-SA 4.0
export const abbreviate = (str: string) => {
  return str
    .match(/(^\S\S?|\s\S)?/g)
    ?.map((v) => v.trim())
    .join("")
    .match(/(^\S|\S$)?/g)
    ?.join("")
    .toLocaleUpperCase();
};
